import { MsgService, MsgSeverities } from './../services/message.service';
import { LoaderService } from 'src/app/services/loader.service';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ServerError } from '../model/server-error.model';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

    constructor(
        private loader: LoaderService,
        private msgService: MsgService
     ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (localStorage.getItem('token')) {
            req = req.clone({
                setHeaders: {
                    token: localStorage.getItem('token')
                }
            });
            return this.handleReqErrors(req, next);
        } else {
            return next.handle(req);
        }
    }

    handleReqErrors(req: HttpRequest<any>, next: HttpHandler) {
        this.loader.show();
        return next.handle(req).pipe(
            map((event: HttpEvent<any>) => {
                this.loader.hide();
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                this.loader.hide();
                if (error.error) {
                    let serverError: ServerError;
                    if (error.error instanceof ArrayBuffer) {
                        const errStr = String.fromCharCode.apply(null, new Uint8Array(error.error));
                        serverError = JSON.parse(errStr);
                    } else {
                        serverError = error.error;
                    }
                    this.msgService.showMsg(
                        MsgSeverities.ERROR, 
                        serverError.status + ' ' + serverError.error, 
                        serverError.path + ' - ' + serverError.message, true);
                } else {
                    const start = error.url.indexOf('remiddleware');
                    const apiService = error.url.substring(start, error.url.length);
                    this.msgService.showMsg(
                        MsgSeverities.ERROR, 
                        'Attenzione', 
                        'Si è verificato un errore durante la richiesta: ' + apiService);
                }
                return of(null);
            })
        );
    }
}